"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.padZeros = padZeros;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var DELIMITER = '-';
var TIMESUFFIX = 'T00:00';
var cache = {
  1: '0',
  2: '00'
};
function padZeros(n, td) {
  var ns = n.toString();
  var l = ns.length;
  var z = '';
  if (td > l) {
    z = cache[td - l];
  }
  return z + ns;
}

// Return a yyyy-mm-dd format for date d;
function yyyymmdd(d) {
  return d.getFullYear() + DELIMITER + padZeros(d.getMonth() + 1, 2) + DELIMITER + padZeros(d.getDate(), 2);
}
// Return a yyyy-mm-ddThh:mm:ssZ format for date d;
function yyyymmddhhmmss(d) {
  return "".concat(yyyymmdd(d), "T").concat(padZeros(d.getHours(), 2), ":").concat(padZeros(d.getMinutes(), 2), ":").concat(padZeros(d.getSeconds(), 2), "Z");
}
var DateTimeFormat = /*#__PURE__*/function () {
  function DateTimeFormat() {
    (0, _classCallCheck2["default"])(this, DateTimeFormat);
  }
  (0, _createClass2["default"])(DateTimeFormat, null, [{
    key: "toAPIString",
    value:
    // TODO more format support
    function toAPIString(date /** , format = 'YYYY-MM-dd'**/) {
      var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TIMESUFFIX;
      if (!date) {
        return '';
      }
      return yyyymmdd(date) + suffix;
    }
  }, {
    key: "now",
    value: function now() {
      var d = new Date();
      return yyyymmddhhmmss(d);
    }
  }]);
  return DateTimeFormat;
}();
var _default = DateTimeFormat;
exports["default"] = _default;